module.exports = __webpack_public_path__ + "img/5.8139040a.png";